import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import styles from './NotFound.module.scss';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <h1>{t('not_found')}</h1>
      <p>
        <Trans
          i18nKey="we_werent_able_to_find_the_page_youre_looking_for_please_reach_out_to_support_for_assistance"
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          components={{ 0: <a href="mailto:support@fitracking.com" /> }}
        />
      </p>
    </div>
  );
}
